import { FormFieldComponent } from './components';
import { FormFieldGroup } from './components/group';
import { FormFieldFeedbackAlert } from './parts/feedback-alert';

export const FormField = Object.assign(FormFieldComponent, {
  Group: FormFieldGroup,
  FeedbackAlert: FormFieldFeedbackAlert
});
